import React from 'react'
import { AeronetViewProps } from '../types';
import DueDateDataGrid from './DueDateDataGrid';
import type { DueDateView } from './type';


interface DueDateListProps extends AeronetViewProps{
/** Which register this mode lists: per-person due dates, or the templates. */
view: DueDateView
canCreateDuedate:boolean
canEditDuedate:boolean
canDeleteDuedate:boolean
}

// No ListingHeader here — DueDateLayout's breadcrumb is the page's only
// header; a second title bar here would double it (BP-14).
const DueDateList:React.FC<DueDateListProps> = (props) => {
    const {title,originalUrl,view,canCreateDuedate,canEditDuedate,canDeleteDuedate} = props
  return (
    <DueDateDataGrid
    view={view}
    originalUrl={originalUrl}
    title={title}
    canCreateDuedate= {canCreateDuedate}
    canEditDuedate = {canEditDuedate}
    canDeleteDuedate = {canDeleteDuedate}
    />
  )
}

export default DueDateList
